import * as currency from './currency'
import * as dates from './dates'

export default {
  currency,
  dates
}



// WEBPACK FOOTER //
// ./src/filters/index.js